const isDevelopment = process.env.NODE_ENV === "development";

const config = {
    baseUrl: process.env.REACT_APP_API_BASE_URL || (isDevelopment ? "" : "https://www.pointgenie.com"),
    apiServer: "/api/"
}

export default config;
